// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__pwEFT","title":"ClientCherryInfo_title__2UDis","itemText":"ClientCherryInfo_itemText__2HECX"};